// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export default function promisifyMsSubtleCrypto(backend) {
    const usages = [
        'decrypt',
        'digest',
        'encrypt',
        'exportKey',
        'generateKey',
        'importKey',
        'sign',
        'verify',
    ];
    const decorateUsage = (fakeBackend, usage) => decorate(backend, fakeBackend, usage);
    return usages.reduce(decorateUsage, {});
}
function decorate(subtle, fakeBackend, name) {
    fakeBackend[name] = async (...args) => {
        return new Promise((resolve, reject) => {
            // @ts-ignore
            const operation = subtle[name](...args);
            operation.oncomplete = () => resolve(operation.result);
            operation.onerror = reject;
        });
    };
    return fakeBackend;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvbWlzaWZ5LW1zLWNyeXB0by5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9taXNpZnktbXMtY3J5cHRvLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG9FQUFvRTtBQUNwRSxzQ0FBc0M7QUFNdEMsTUFBTSxDQUFDLE9BQU8sVUFBVSx1QkFBdUIsQ0FBQyxPQUF1QjtJQUNyRSxNQUFNLE1BQU0sR0FBd0I7UUFDbEMsU0FBUztRQUNULFFBQVE7UUFDUixTQUFTO1FBQ1QsV0FBVztRQUNYLGFBQWE7UUFDYixXQUFXO1FBQ1gsTUFBTTtRQUNOLFFBQVE7S0FDVCxDQUFBO0lBQ0QsTUFBTSxhQUFhLEdBQUcsQ0FBQyxXQUFnQixFQUFFLEtBQXdCLEVBQUUsRUFBRSxDQUNuRSxRQUFRLENBQUMsT0FBTyxFQUFFLFdBQVcsRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUN2QyxPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsYUFBYSxFQUFFLEVBQUUsQ0FBaUIsQ0FBQTtBQUN6RCxDQUFDO0FBRUQsU0FBUyxRQUFRLENBQ2YsTUFBc0IsRUFDdEIsV0FBZ0IsRUFDaEIsSUFBdUI7SUFFdkIsV0FBVyxDQUFDLElBQUksQ0FBQyxHQUFHLEtBQUssRUFBRSxHQUFHLElBQVcsRUFBRSxFQUFFO1FBQzNDLE9BQU8sSUFBSSxPQUFPLENBQUMsQ0FBQyxPQUFPLEVBQUUsTUFBTSxFQUFFLEVBQUU7WUFDckMsYUFBYTtZQUNiLE1BQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxHQUFHLElBQUksQ0FBQyxDQUFBO1lBQ3ZDLFNBQVMsQ0FBQyxVQUFVLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQTtZQUN0RCxTQUFTLENBQUMsT0FBTyxHQUFHLE1BQU0sQ0FBQTtRQUM1QixDQUFDLENBQUMsQ0FBQTtJQUNKLENBQUMsQ0FBQTtJQUNELE9BQU8sV0FBVyxDQUFBO0FBQ3BCLENBQUMifQ==